<div class="p-2">
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <div class="d-flex justify-content-end align-items-center mb-2" style="gap:12px; margin-bottom:15px;">

    <!-- Property Multi-select -->
    <p-multiSelect [options]="properties" [(ngModel)]="selectedProperties" optionLabel="name" optionValue="id"
      [filter]="true" filterBy="name" defaultLabel="Select Property" appendTo="body" [style]="{'width':'320px'}"
      display="chip" [dropdownIcon]="'fa fa-caret-down'">
    </p-multiSelect>

    <!-- Quality Multi-select -->
    <p-multiSelect [options]="qualityOptions" [(ngModel)]="selectedQualities" defaultLabel="Select Quality"
      optionLabel="label" optionValue="value" display="chip" appendTo="body" [style]="{'width':'200px'}"
      [dropdownIcon]="'fa fa-caret-down'">
    </p-multiSelect>

    <!-- Run Button -->
    <button pButton pRipple class="p-button p-button-primary" style="padding: 0.5rem 1rem;"
      (click)="runQualityTest()">
      Run Quality Test
    </button>
  </div>
  @if (analyticsData) {
    <div class="row mt-4">
      @for (subCategory of objectKeys(subCategoryStringMappings); track subCategory) {
        <div class="col-lg-4 mb-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title fs-5 fw-bold mb-3">
                {{ subCategoryStringMappings[subCategory] }}
              </h5>
              <table class="table table-bordered table-sm analytics-table">
                <thead class="table-light">
                  <tr>
                    <th scope="col" style="width: 45%;">Job</th>
                    <!-- Daily sync: show last 4 days -->
                    @if (subCategory === 'VRBO_DAILY_SYNC' || subCategory === 'GOOGLE_DAILY_SYNC') {
                      @for (d of analyticsData[subCategory]?.dailyLast4; track d) {
                        <th scope="col" class="text-center">
                          {{ d.label }}
                        </th>
                      }
                    } @else {
                      <th scope="col" class="text-center">{{ getDateLabel('today') }}</th>
                      <th scope="col" class="text-center">{{ getDateLabel('yesterday') }}</th>
                      <th scope="col" class="text-center">30-Day</th>
                    }
                    <!-- Non-VRBO: today, yesterday, 30-day -->
                  </tr>
                </thead>
                <tbody>
                  @for (refId of getOrderedRefs(subCategory); track refId) {
                    <tr>
                      <td>{{ referenceIdStringMappings[refId] || refId }}</td>
                      <!-- Daily sync: last 4 daily cells -->
                      @if (subCategory === 'VRBO_DAILY_SYNC' || subCategory === 'GOOGLE_DAILY_SYNC') {
                        @for (d of analyticsData[subCategory]?.dailyLast4; track d) {
                          <td class="text-center clickable" (click)="onAnalyticsClickDate(d.dateStr, subCategory, refId)">
                            <div [ngClass]="getBgClass(d.data?.[refId])" class="analytics-cell">
                              <div class="analytics-number">{{ d.data?.[refId]?.actual || 0 }}</div>
                              @if (d.data?.[refId]; as dd) {
                                @if (shouldShowFraction(refId)) {
                                  <div class="analytics-sub">{{ dd.actual || 0 }}/{{ dd.expected || 0 }}</div>
                                }
                              }
                            </div>
                          </td>
                        }
                      } @else {
                        <td class="text-center clickable" (click)="onAnalyticsClick('today', subCategory, refId)">
                          <div [ngClass]="getBgClass(analyticsData[subCategory]?.today?.[refId])" class="analytics-cell">
                            <div class="analytics-number">{{ analyticsData[subCategory]?.today?.[refId]?.actual || 0 }}</div>
                            @if (analyticsData[subCategory]?.today?.[refId]; as d) {
                              @if (shouldShowFraction(refId)) {
                                <div class="analytics-sub">{{ d.actual || 0 }}/{{ d.expected || 0 }}</div>
                              }
                            }
                          </div>
                        </td>
                        <td class="text-center clickable" (click)="onAnalyticsClick('yesterday', subCategory, refId)">
                          <div [ngClass]="getBgClass(analyticsData[subCategory]?.yesterday?.[refId])" class="analytics-cell">
                            <div class="analytics-number">{{ analyticsData[subCategory]?.yesterday?.[refId]?.actual || 0 }}</div>
                            @if (analyticsData[subCategory]?.yesterday?.[refId]; as d) {
                              @if (shouldShowFraction(refId)) {
                                <div class="analytics-sub">{{ d.actual || 0 }}/{{ d.expected || 0 }}</div>
                              }
                            }
                          </div>
                        </td>
                        <td class="text-center clickable" (click)="onAnalyticsClick('last30Days', subCategory, refId)">
                          <div [ngClass]="getBgClass(analyticsData[subCategory]?.last30Days?.[refId])" class="analytics-cell">
                            <div class="analytics-number">{{ analyticsData[subCategory]?.last30Days?.[refId]?.actual || 0 }}</div>
                            @if (analyticsData[subCategory]?.last30Days?.[refId]; as d) {
                              @if (shouldShowFraction(refId)) {
                                <div class="analytics-sub">{{ d.actual || 0 }}/{{ d.expected || 0 }}</div>
                              }
                            }
                          </div>
                        </td>
                      }
                      <!-- Non-VRBO: today, yesterday, 30-day -->
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div class="grid-container" id="data-report-grid">

    <!-- Quartz Jobs - Last 3 Days -->
    @if (quartzAnalytics) {
      <div class="row mt-3">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title fs-5 fw-bold mb-3">Quartz Jobs (Last 3 Days)</h5>
              <div style="max-height: 300px; overflow: auto;">
                <table class="table table-bordered table-sm analytics-table">
                  <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
                    <tr>
                      <th scope="col" style="width: 45%;">Job</th>
                      <th scope="col" class="text-center" style="width: 20%;">Prev / Next</th>
                      <th scope="col" class="text-center" style="width: 18%;">Actions</th>
                      @for (d of quartzAnalytics.days; track d) {
                        <th scope="col" class="text-center">{{ d.label }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (job of quartzAnalytics.jobNames; track job) {
                      <tr>
                        <td>{{ job }}</td>
                        <td class="text-center">
                          <div class="small"><strong>Prev:</strong> {{ formatTime(quartzAnalytics.todayTimes?.[job]?.prevFireTime) }}</div>
                          <div class="small"><strong>Next:</strong> {{ formatTime(quartzAnalytics.todayTimes?.[job]?.nextFireTime) }}</div>
                        </td>
                        <td class="text-center">
                          <div class="d-flex justify-content-center flex-wrap" style="gap: 0.25rem;">
                            <button pButton pRipple type="button" class="p-button-sm p-button-success"
                              label="Trigger"
                              [disabled]="isAnyQuartzActionLoading(job)"
                              (click)="triggerQuartzJobNow(job)">
                            </button>
                            <button pButton pRipple type="button" class="p-button-sm p-button-warning"
                              label="Reset"
                              [disabled]="isAnyQuartzActionLoading(job)"
                              (click)="resetQuartzTriggerState(job)">
                            </button>
                            <button pButton pRipple type="button" class="p-button-sm p-button-danger"
                              label="Recover"
                              [disabled]="isAnyQuartzActionLoading(job)"
                              (click)="recoverQuartzStaleStarted(job)">
                            </button>
                          </div>
                        </td>
                        @for (d of quartzAnalytics.days; track d) {
                          <td class="text-center clickable" (click)="onQuartzClickDate(d.dateStr, job)">
                            <div [ngClass]="getQuartzCellBgClass(job, d.dateStr, quartzAnalytics.values[job]?.[d.dateStr])" class="analytics-cell">
                              <div class="analytics-number">{{ quartzAnalytics.values[job]?.[d.dateStr]?.actual || 0 }}</div>
                              @if (quartzAnalytics.values[job]?.[d.dateStr]; as cell) {
                                <div class="analytics-sub">{{ cell.actual || 0 }}/{{ cell.expected || 0 }}</div>
                              }
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Loader overlay -->
    @if (formLoading) {
      <div class="d-flex justify-content-center align-items-center"
        style="position:absolute; top:0; left:0; right:0; bottom:0; background:rgba(255,255,255,0.7); z-index:10;">
        <p-progressSpinner></p-progressSpinner>
      </div>
    }

    @if (gridApi?.isAnyFilterPresent()) {
      <div class="d-flex justify-content-end mb-2">
        <button pButton pRipple class="p-button-primary" icon="pi pi-filter-slash" label="Clear All Filters"
        (click)="clearAllFilters()"></button>
      </div>
    }

    <!-- AG Grid -->
    <div class="grid-wrapper" style="height: 60vh; min-height: 400px;">
      <ag-grid-angular style="width: 100%; height: 100%;" class="ag-theme-balham" [rowData]="rowData"
        [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [animateRows]="true" [statusBar]="statusBar"
        rowSelection="multiple" [pagination]="true" [paginationPageSize]="2500" [paginationAutoPageSize]="false"
        [domLayout]="'normal'" [suppressHorizontalScroll]="false" (rowClicked)="onRowClicked($event)"
        (gridReady)="onGridReady($event)" (firstDataRendered)="onFirstDataRendered($event)">
      </ag-grid-angular>
    </div>

  </div>

  <!-- Details Dialog -->
  <div class="data-report-details-dialog">
    <p-dialog [(visible)]="displayDialog" [modal]="true" [closable]="true" [resizable]="true" [draggable]="true"
      [style]="{width: '90vw', height: '80vh'}" [contentStyle]="{'max-height': '80vh', 'overflow': 'auto'}"
      header="Data Report Details" (onHide)="closeDialog()">

      @if (selectedRowData) {
        <div class="details-container">
          <div class="details-header my-4">
            <div class="d-flex gap-4">
              <div class="d-flex align-items-center">
                <h3 class="text-primary mb-2">
                  <i class="pi pi-calendar me-2"></i>
                  <span class="fw-bold">{{ selectedRowData.createDate ? (selectedRowData.createDate |
                  date:'medium') : 'N/A' }}</span>
                </h3>
              </div>
              <div class="text-end">
							<span class="badge" [ngClass]="{
										'bg-success': selectedRowData.testResultStatus === 1,
										'bg-warning': selectedRowData.testResultStatus === 2,
										'bg-danger': selectedRowData.testResultStatus === 3,
										'bg-info': selectedRowData.testResultStatus === 4
									}">
                  {{ statusMap[selectedRowData.testResultStatus] || 'Unknown' }}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Rental ID</span>
              <span class="ms-2">
                @if (selectedRowData.shortTermRentalId) {
                  <a [href]="'https://admin.kbmhawaii.com/property-edit/' + selectedRowData.shortTermRentalId" target="_blank" rel="noopener" (click)="$event.stopPropagation()">
                    {{ selectedRowData.shortTermRentalId }}
                  </a>
                } @else {
                  N/A
                }
              </span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Reservation ID</span>
              <span class="ms-2">{{ selectedRowData.reservationId || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Property Code</span>
              <span class="ms-2">{{ selectedRowData.propertyCode || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Development Name</span>
              <span class="ms-2">{{ selectedRowData.adrDevelopmentName || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Development ID</span>
              <span class="ms-2">{{ selectedRowData.developmentId || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Feature ID</span>
              <span class="ms-2">{{ selectedRowData.featureId || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Expected Result</span>
              <span class="ms-2">{{ selectedRowData.testExpectedResult || 'No expected result specified' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Actual Result</span>
              <span class="ms-2">{{ selectedRowData.testActualResult || 'No actual result specified' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Deviation</span>
              <span class="ms-2">{{ selectedRowData.deviation || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Job Type</span>
              <span class="ms-2">{{ referenceIdStringMappings[selectedRowData.referenceId] || selectedRowData.referenceId || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Test Name</span>
              <span class="ms-2">{{ selectedRowData.testName || 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Category</span>
              <span class="ms-2">{{ selectedRowData.testCategoryName ? (selectedRowData.testCategoryName | titlecase) : 'N/A' }}</span>
            </div>
            <div class="mb-2 d-flex align-items-center">
              <span class="fw-bold flex-shrink-0" style="min-width: 170px;">Sub Category</span>
              <span class="ms-2">{{ subCategoryStringMappings[selectedRowData.testSubCategoryName] || selectedRowData.testSubCategoryName || 'N/A' }}</span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <div class="fw-bold">Description</div>
              <div class="mt-2">{{ selectedRowData.testDesc || 'N/A' }}</div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <div class="fw-bold">Result Description</div>
              <div class="mt-2">{{ selectedRowData.testResultDesc || 'N/A' }}</div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <div class="my-2" [innerHTML]="getFormattedResultUrl(selectedRowData.testResultUrl)"></div>
            </div>
          </div>
          @if (hasMetadataForDialog) {
            <div class="row mt-3">
              <div class="col-md-12">
                <div class="d-flex align-items-center justify-content-between">
                  <div class="fw-bold">Metadata</div>
                  <button type="button" class="btn btn-link btn-sm p-0" (click)="toggleMetadataCollapse()">
                    {{ metadataExpanded ? 'Collapse' : 'Expand' }}
                  </button>
                </div>
                @if (metadataExpanded) {
                  <div class="section-content mt-2" [innerHTML]="formattedMetadataForDialog"></div>
                }
              </div>
            </div>
          }
        </div>
      }
    </p-dialog>
  </div>
</div>